import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "./useAuth";

interface UserRoleState {
  isPlatformOwner: boolean;
  isOrgOwner: boolean;
  userRole: string | null;
  loading: boolean;
}

export const useUserRole = () => {
  const { user, isPlatformOwner } = useAuth();
  const [state, setState] = useState<UserRoleState>({
    isPlatformOwner: false,
    isOrgOwner: false,
    userRole: null,
    loading: true,
  });

  useEffect(() => {
    if (!user) {
      setState({
        isPlatformOwner: false,
        isOrgOwner: false,
        userRole: null,
        loading: false,
      });
      return;
    }

    const fetchRoles = async () => {
      try {
        // Get all roles for the user
        const { data: roles } = await supabase
          .from('user_roles')
          .select('role, org_id')
          .eq('user_id', user.id);

        const isOrgOwner = roles?.some(r => r.role === 'owner' && r.org_id !== null) || false;

        setState({
          isPlatformOwner,
          isOrgOwner,
          userRole: roles?.[0]?.role || null,
          loading: false,
        });
      } catch (error) {
        console.error('Error fetching user roles:', error);
        setState({
          isPlatformOwner,
          isOrgOwner: false,
          userRole: null,
          loading: false,
        });
      }
    };

    fetchRoles();
  }, [user, isPlatformOwner]);

  return state;
};
